<ng-template #aamBlockUi>
    <p-button
        [pTooltip]="
            !checkIfCanSave()
                ? ('product.save-product-first' | translate)
                : ('product.missing-data-for-save' | translate)
        "
        [loading]="isSaving()"
        icon="fa fa-save"
        [label]="'product.save-product-first' | translate"
        [disabled]="checkIfCanSave()"
        (onClick)="saveToUnlockEditMode()"
    ></p-button>
</ng-template>

<blockable-div
    #aamBlock
    [class]="blockableClass"
    [style]="blockedStyle"
    [blocked]="isBlocked"
    [blockUi]="aamBlockUi"
>
    @if (product?.id) {
        <div class="w-full">
            <div style="text-align: center; margin: 1em">
                @if (isComponentRendered()) {
                    <app-asset-file-input
                        #assetFileInput
                        (selectFiles)="createAssets($event)"
                        [noUploadButton]="true"
                        [dropZoneTargetModelSig]="assetListWidget().table()?.el"
                    />
                }
            </div>
            <app-widget-asset-list
                #assetList
                [showUploadButton]="true"
                [fillHeightList]="false"
                (isComponentRendered)="isComponentRendered.set($event)"
                (selectFiles)="createAssets($event)"
                [modelIdSig]="product.id"
                [modelTypeSig]="'ProductAsset'"
                [dataTestId]="'formly-product-assets'"
            />

            <h6 class="mt-4 mb-2 text-primary font-semibold">{{ 'common.journal-entries' | translate }}</h6>
            <hr class="mb-2 border-gray-200 !opacity-50" />
            <app-journal-list-widget
                #journalListWidget
                [autoFocusSearch]="false"
                [fillHeightList]="false"
                [addInDialog]="true"
                [dialogEditMode]="true"
                [checkboxMode]="false"
                [autoloadItems]="false"
            />

            <h6 class="mt-4 mb-2 text-primary font-semibold">{{ 'task.task-list' | translate }}</h6>
            <hr class="mb-2 border-gray-200 !opacity-50" />
            <app-task-list-widget
                #taskListWidget
                [autoFocusSearch]="false"
                [fillHeightList]="false"
                [addInDialog]="true"
                [dialogEditMode]="true"
                [checkboxMode]="false"
                [autoloadItems]="false"
            />
        </div>
    }
</blockable-div>
